import * as React from 'react';
import * as I18n from 'i18n-js';
import { useUser } from '@reverbdotcom/commons/dist/user_hooks';
import Currency from '@reverbdotcom/commons/dist/currency';
import LocalePickerModal from './locale_picker/locale_picker_modal';
import { LANGUAGES } from './shared/constants';

export default function LocaleSwitcher() {
  const [isModalOpen, setModalOpen] = React.useState(false);
  const { locale, currency, shippingRegionCode } = useUser();
  const language = LANGUAGES[locale];

  const closeModal = React.useCallback(() => {
    setModalOpen(false);
  }, []);

  const openModal = React.useCallback(() => {
    setModalOpen(true);
  }, []);

  return (
    <>
      {isModalOpen && <LocalePickerModal isOpen onClose={closeModal} />}
      <button
        type="button"
        className="locale-switcher"
        onClick={openModal}
      >
        <span>
          {I18n.t(`discovery.shippingRegions.${shippingRegionCode}`)}
        </span>
        <span>
          {language}
        </span>
        <span>
          {`${Currency.get(currency).symbol} ${currency}`}
        </span>
      </button>
    </>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/locale_switcher.tsx